import React, { useState, useEffect, useRef } from "react";

import axios from 'axios';
import './InFlightPage.css';
import TopNav from "../components/TopNav";
import InFlightMap from "../components/InFlightMap";
import InFlightTable from "../components/InFlightTable";
import InFlightMobile from "../components/InFlightMobile";

const InFlightPage = (props) => {
    const [flightData, setFlightData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const mapRef = useRef(null);

    // Fetch flight data from API
    const fetchFlightData = async () => {
        try {
            // Add cache busting parameter
            //const cacheBuster = Math.random();
            //const response = await fetch(`https://fdxva.org/api/inflight.php?x=${cacheBuster}`);
            const result = await axios.get("/api/inflight", {
                params: { _t: Date.now() }
            }); 
            
            console.log(result.data)
            
            // if (!response.ok) {
            //     throw new Error('Failed to fetch flight data');
            // }
            
            const data = result.data;
            setFlightData(data);
            setError(null);
        } catch (err) {
            console.error('Error fetching flight data:', err);
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    // Initial fetch and set up refresh interval
    useEffect(() => {
        fetchFlightData();
        
        // Refresh every 15 seconds
        const interval = setInterval(fetchFlightData, 15000);
        
        return () => clearInterval(interval);
    }, []);

    // Handle row/flight click - center map on selected flight
    const handleFlightClick = (index, flight) => {
        if (mapRef.current && mapRef.current.centerOnFlight) {
            mapRef.current.centerOnFlight(index);
        }
    };

    return (
        <React.Fragment>
            {/* TopNav - hidden on mobile */}
            <div className="desktop-only">
                <TopNav page={props.page} darkMode={props.darkmode}/>
            </div>
            
            <div className={`inflight-page-container ${props.darkmode ? 'dark-theme' : 'light-theme'}`}>
                
                {loading && (
                    <div className="loading-message">
                        <p>Loading flight data...</p>
                    </div>
                )}

                {error && (
                    <div className="error-message">
                        <p>Error: {error}</p>
                    </div>
                )}

                {!loading && !error && (
                    <>
                        {/* Desktop Table View and Map */}
                        <div className="desktop-content">
                            <InFlightTable
                                flightData={flightData}
                                onRowClick={handleFlightClick}
                            />
                            <InFlightMap
                                ref={mapRef}
                                flightData={flightData}
                                onMarkerClick={handleFlightClick}
                            />
                        </div>

                        {/* Mobile View - Table Only, No Map */}
                        <InFlightMobile
                            flightData={flightData}
                            onFlightClick={handleFlightClick}
                        />
                    </>
                )}
            </div>
        </React.Fragment>
    );
};

export default InFlightPage;
